import { render, staticRenderFns } from "./smspackage.vue?vue&type=template&id=52f3b428&"
import script from "./smspackage.vue?vue&type=script&lang=ts&"
export * from "./smspackage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "smspackage.vue"
export default component.exports